export enum GeofenceEditMarkerStep {
  MapPin = 'map-pin',
  SelectShape = 'select-shape',
  Create = 'create',
  Edit = 'edit',
  Measurement = 'measurement',
}

export enum VehicleMarkerDisplayMode {
  Vehicle = 'vehicle',
  Driver = 'driver',
}
